import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Certificate } from '../models';

export const certificatesActions = createActionGroup({
    source: 'Certificates',
    events: {
        'Get Certificates': emptyProps(),
        'Get Certificates Success': props<{ payload: Certificate[] }>(),
        'Get Certificates Error': emptyProps(),
        Clear: emptyProps(),
    },
});
